import { useEffect, useMemo, useState } from 'react';

import {
  type AssetsPublicationTemplateSchemaWithIdNullable,
  httpGetPublicationsTemplates,
} from '@iconik-io/iconik-api/src/services/assets';
import { SelectField } from '@iconik-io/uad';

import { useAppDispatch } from '../../../../../../redux/redux_hooks';

type SelectTemplateFieldsProps = {
  onSelectionChange: (
    templateId: AssetsPublicationTemplateSchemaWithIdNullable['id'] | null,
  ) => void;
  selectedTemplateId: string | null;
  onLoadComplete?: (hasTemplates: boolean) => void;
  name?: string;
  ariaLabel?: string;
  isClearable?: boolean;
  isDisabled?: boolean;
  placeholder?: string;
};

export function SelectTemplateField({
  onSelectionChange,
  selectedTemplateId,
  onLoadComplete,
  name,
  ariaLabel,
  isClearable,
  isDisabled,
  placeholder,
}: SelectTemplateFieldsProps) {
  const dispatch = useAppDispatch();
  const [templates, setTemplates] = useState<
    AssetsPublicationTemplateSchemaWithIdNullable[]
  >([]);

  useEffect(() => {
    dispatch(httpGetPublicationsTemplates()).then(({ body }) => {
      setTemplates(body.objects);
      onLoadComplete?.(body.objects.length > 0);
    });
  }, [onLoadComplete]);

  const handleSelectionChange = (key: string | number | null) => {
    const templateId = templates.find((item) => item.id === key)?.id ?? null;
    onSelectionChange(templateId);
  };

  const templateOptions = useMemo(
    () =>
      templates.map((template) => ({
        id: template.id,
        label: template.name ?? '',
      })),
    [templates],
  );

  return (
    <SelectField
      aria-label={ariaLabel}
      name={name}
      isClearable={isClearable}
      isDisabled={isDisabled}
      placeholder={placeholder}
      value={selectedTemplateId}
      onChange={handleSelectionChange}
      options={templateOptions}
      size="l"
    />
  );
}
